import type { DeliveryFilter } from "../lib/delivery";
import type { NotifFilter } from "../lib/notif";

export const notifKeys = {
  all: ["notifications"] as const,
  lists: ["notifications", "list"] as const,
  list: (filter?: NotifFilter) => [...notifKeys.lists, filter] as const,
  settings: () => [...notifKeys.all, "settings"] as const,
  deliveries: (filter: DeliveryFilter) => [...notifKeys.all, "deliveries", filter] as const,
};
